import { Component, Input } from '@angular/core';
import { DomainDpStatus, DomainDpStatusLabels } from '../../domain/domain-dp-approval.model';

@Component({
  selector: 'cm-domain-dp-status-circle',
  template: `
    <span class="status-circle"
          [matTooltip]="showTooltip ? DomainDpStatusLabels[status]:''"
          [ngClass]="{
        'status-circle--orange': status === DomainDpStatus.PENDING,
        'status-circle--green': status === DomainDpStatus.APPROVED,
        'status-circle--red': status === DomainDpStatus.REJECTED}">
      <i class="fas fa-circle"></i>
    </span>
    <span #ref [ngClass]="ref.children.length >0 ?'pl-2':''" class="ml-1"> 
      <ng-content></ng-content>
    </span>`,
  host: {'class': 'cm-domain-dp-status-circle'}
})
export class DomainDpStatusCircleComponent {

  @Input()
  public status: DomainDpStatus;

  @Input()
  showTooltip = true;

  public DomainDpStatus = DomainDpStatus;
  public DomainDpStatusLabels = DomainDpStatusLabels;

}
